import React, { FC, ReactElement, useEffect, useState } from "react";
import useWindowDimensions from "../../core/hooks/useWindowDimensions";

import styles from "../../styles/GlobalModal.module.scss";

interface ModalProps {
  visible: boolean
  title: ReactElement | string
  image?: ReactElement | string
  content: ReactElement | string
  maxWidth?: string
  closable?: boolean
  onClose: () => void
}

const GlobalModal: FC<ModalProps> = ({visible, title, content, image, closable = true, maxWidth = "550px", onClose}) => {

  const { width } = useWindowDimensions()

  const [ hidingProceed, setHidingProceed ] = useState(false);
  const [ showedProc, setShowedProc ] = useState(false);

  const onKeydown = ({ key }: KeyboardEvent) => {
    switch (key) {
      case 'Escape':
        if (closable) {
          setHidingProceed(true)
          setShowedProc(false)
          setTimeout(() => {
            onClose();
            setHidingProceed(false);
          }, 300);
        }
        break;
    }
  }

  const onCloseRef = () => {
    setHidingProceed(true)
    setShowedProc(false)
    setTimeout(() => {
      onClose();
      setHidingProceed(false);
    }, 300);
  }

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        setShowedProc(true)
      }, 100);
      document.getElementsByTagName("html")[0].style.overflowY = "hidden"
    } else {
      document.getElementsByTagName("html")[0].style.overflowY = "scroll"
    }
  }, [visible])

  useEffect(() => {
    document.addEventListener('keydown', onKeydown)
    return () => {
      document.removeEventListener('keydown', onKeydown)
    }
  }, [])

  if (!visible) return null
  
  return (
    <div className={styles.modal} style={{opacity: hidingProceed ? "0" : "1"}} onClick={() => onCloseRef()}>
      <span style={{display: closable ? "block" : "none"}} className={styles.modal_header__close} onClick={onCloseRef}>
        {width > 768 ? <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L25 25" stroke="white" stroke-width="2"/>
          <path d="M25 1L0.999998 25" stroke="white" stroke-width="2"/>
        </svg> : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L15 15" stroke="white"/>
          <path d="M15 1L0.999998 15" stroke="white"/>
        </svg>}
      </span>
      <div className={styles.modal_dialog} style={{maxWidth: maxWidth, right: !showedProc ? "-45%" : "0%"}} onClick={e => e.stopPropagation()}>
        <div className={styles.modal_header}>
          
        </div>
        <div className={styles.modal_body}
          style={{
            padding: parseInt(maxWidth) > 420 ? "0px 0px" : "0px"
          }}>
          <div className={styles.modal_body__content}>{content}</div>
        </div>
      </div>
    </div>
  )
}

export default GlobalModal